<script lang="ts">
	import DefaultButton from '../../../../basic/buttons/DefaultButton.svelte';
	import DefaultNumberInput from '../../../../basic/input/DefaultNumberInput.svelte';
	import DefaultTextInput from '../../../../basic/input/DefaultTextInput.svelte';
	import InputLabel from '../../../../basic/input/InputLabel.svelte';
	import Modal from '../../../../basic/modal/Modal.svelte';
	import ModalHeader from '../../../../basic/modal/ModalHeader.svelte';
	import { handleStoreError } from '../../../../stores/GeneralStore';
	import { type SettingDocumentNameGeneratorStore } from '../../../../stores/SettingDocumentNameGeneratorsStore.svelte';
	import type {
		PatchSettingDocumentNameGenerator,
		SettingDocumentNameGenerator
	} from '../../../../types/BasicTypes';
	import { _ } from 'svelte-i18n';

	interface Props {
		store: SettingDocumentNameGeneratorStore;
		targetItem: SettingDocumentNameGenerator;
		onModalClose: () => void;
	}

	let { store, targetItem, onModalClose }: Props = $props();

	//Build the request
	// svelte-ignore state_referenced_locally
	let request: PatchSettingDocumentNameGenerator = $state({
		defaultName: targetItem.defaultName,
		startingNumber: targetItem.startingNumber,
		minNumberLength: targetItem.minNumberLength,
		pattern: targetItem.pattern
	});

	async function handlePatch() {
		try {
			await store.patchSettingDocumentNameGeneratorStore(targetItem!.id, request);
			//Close down the modal
			onModalClose();
		} catch (err) {
			handleStoreError('settings.basic.document_name_generators.err_patch', err);
		}
	}
</script>

<Modal {onModalClose} onModalEnter={handlePatch}>
	{#snippet header()}
		<ModalHeader text={$_('settings.basic.document_name_generators.lbl_patch_header')} />
	{/snippet}
	{#snippet content()}
		<div class="grid gap-2">
			<!--Name-->
			<InputLabel label={$_('settings.basic.document_name_generators.lbl_name')} />
			<DefaultTextInput propertyName="defaultName" bind:value={request.defaultName} />
			<!--Starting number-->
			<InputLabel label={$_('settings.basic.document_name_generators.lbl_starting_number')} />
			<DefaultNumberInput
				propertyName="startingNumber"
				min={0}
				max={1000000}
				bind:value={request.startingNumber}
			/>
			<!--Minimal number length-->
			<InputLabel label={$_('settings.basic.document_name_generators.lbl_min_length')} />
			<DefaultNumberInput
				propertyName="minNumberLength"
				min={0}
				max={8}
				bind:value={request.minNumberLength}
			/>
			<p class="text-sm">
				*{request.startingNumber?.toString().padStart(request.minNumberLength || 0, '0')}
			</p>
			<!--Pattern-->
			<InputLabel label={$_('settings.basic.document_name_generators.lbl_pattern')} />
			<DefaultTextInput propertyName="pattern" bind:value={request.pattern} />
			<p class="text-sm">
				*{$_('settings.basic.document_name_generators.lbl_pattern_description')}
			</p>
		</div>
	{/snippet}
	{#snippet footer()}
		<div>
			<!-- Buttons-->
			<div class="flex justify-end gap-4">
				<DefaultButton
					secondary={true}
					text={$_('general.lbl_cancel')}
					onClick={() => {
						onModalClose();
					}}
				/>
				<DefaultButton onClick={handlePatch} text={$_('general.lbl_accept')} />
			</div>
		</div>
	{/snippet}
</Modal>
